import { render, staticRenderFns } from "./promotion_panicbuy_choice.vue?vue&type=template&id=77c096e5&scoped=true&"
import script from "./promotion_panicbuy_choice.vue?vue&type=script&lang=ts&"
export * from "./promotion_panicbuy_choice.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_panicbuy_choice.vue?vue&type=style&index=0&id=77c096e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c096e5",
  null
  
)

export default component.exports